"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDom = require("react-dom");

var _message = _interopRequireDefault(require("./message"));

var AppMessage = function AppMessage(props) {
  var isVisible = props.isVisible,
      message = props.message,
      variant = props.variant,
      timeout = props.timeout,
      onHideMessage = props.onHideMessage;

  if (isVisible) {
    return (0, _reactDom.createPortal)( /*#__PURE__*/_react["default"].createElement(_message["default"], {
      isVisible: isVisible,
      message: message,
      variant: variant,
      timeout: timeout,
      onHideMessage: onHideMessage
    }), document.body);
  }

  return null;
};

AppMessage.propTypes = {
  isVisible: _propTypes["default"].bool,
  message: _propTypes["default"].node,
  variant: _propTypes["default"].oneOf(['success', 'warning', 'error']),
  timeout: _propTypes["default"].number,
  onHideMessage: _propTypes["default"].func
};
AppMessage.defaultProps = {
  isVisible: false,
  message: undefined,
  variant: 'error',
  timeout: undefined,
  onHideMessage: function onHideMessage() {}
};
var _default = AppMessage;
exports["default"] = _default;